import Visuel from "./Visuel";
export default Visuel;
